function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
/* eslint-disable import/no-extraneous-dependencies */ /* eslint-disable no-unused-vars */ import { from } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { CoralResponse, CoralInterceptor } from "@amzn/ihm-js-coral-client";
import { CSRF_TOKEN_ID } from "@amzn/carrierlogistics-commons/dist/constants/index";
import getCsrfToken from "@amzn/carrierlogistics-commons/dist/utils/csrf";
import isSiteExternal from "../utils/isSiteExternal";
import { PUMS_NAV_LINK } from "../routes";
import { FAILED_TO_FETCH_ERR_MESSAGES } from "../constants";
// This class is used during client construction, and helps to intercept
// the headers during request handling for the passport external App.
var RequestOptionsInterceptorForPassport = /*#__PURE__*/ function(CoralInterceptor1) {
    "use strict";
    _inherits(RequestOptionsInterceptorForPassport, CoralInterceptor1);
    var _super = _createSuper(RequestOptionsInterceptorForPassport);
    function RequestOptionsInterceptorForPassport() {
        var bindings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, RequestOptionsInterceptorForPassport);
        var _this;
        _this = _super.call(this);
        _this.bindings = bindings;
        return _this;
    }
    var _proto = RequestOptionsInterceptorForPassport.prototype;
    /**
   * @param {CoralRequest} request
   * @param {CoralHandler} next
   * @returns
   */ // eslint-disable-next-line class-methods-use-this
    _proto.intercept = function intercept(request, next) {
        // Adding required header
        var headers = [
            [
                "Accept",
                "application/json"
            ],
            [
                "Content-Type",
                "application/json"
            ],
            [
                CSRF_TOKEN_ID,
                getCsrfToken()
            ], 
        ];
        var postData = request.body;
        // To fix `TypeError: Request constructor: HEAD or GET Request cannot have a body.`
        // Added check to not send stringified body
        var modifiedRequest = request.clone(_objectSpread({
            headers: headers,
            credentials: "include"
        }, ![
            "GET",
            "HEAD"
        ].includes(request === null || request === void 0 ? void 0 : request.method) ? {
            body: JSON.stringify(postData)
        } : {}));
        return from(next.handle(modifiedRequest)).pipe(map(function(response) {
            var responseHeaders = response.headers;
            return new CoralResponse(response);
        }), catchError(function(err) {
            if (!isSiteExternal() && (err === null || err === void 0 ? void 0 : err.message) && FAILED_TO_FETCH_ERR_MESSAGES.includes(err === null || err === void 0 ? void 0 : err.message)) {
                // Only applicable for internal Passport UI
                // To address Cookie expire issue in pums but once cookie expire, mons returned the request with cors issue
                // In case of err with Failed to Fetch, 403 forbidden status come but this can't be captured in fetch
                // Failed to Fetch can be caused by multiple issue like incorrect url or http methods or CORS issue
                // Since we use CORAL models, issue like incorrect url or http methods is avoided as signature is
                // always same in both UI and backend as models is deployed in both pipelines so only thing left is
                // CORS which can be solved by directly setting the pums mons backend URL with redirect URI
                // Handled the cases for other browsers as well for Chrome, FireFox, Safari, Edge
                window.location.href = PUMS_NAV_LINK;
            }
            return new CoralResponse(err);
        }));
    };
    return RequestOptionsInterceptorForPassport;
}(CoralInterceptor);
export default RequestOptionsInterceptorForPassport;

//# sourceMappingURL=PassportRequestOptionsInterceptor.js.map